export default __webpack_public_path__ + "static/media/1030.d59f3d47.png";